module.exports = __webpack_public_path__ + "assets/img/report-act-btn-2.89560efc.png";